import styled from "styled-components";
import { RenderImages } from "../../../designComponents/Table/renderMethods";
import { LabelText, SectionTitle, StyledCard } from "./styles";

// Define the prop types
interface Unit {
  title: string;
  images: string[];
}

interface UnitsCardProps {
  units: Unit[];
}

function UnitsCard({ units }: UnitsCardProps) {
  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle>Rooms</SectionTitle>
      <RoomInformationContainerStyled>
        {units.map((unit, index) => (
          <div key={index}>
            <LabelText size={"largeTitle"} fontWeight="bold">
              {unit.title}
            </LabelText>
            <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
              <RenderImages images={unit.images} displayImage resize={true} />
            </div>
          </div>
        ))}
      </RoomInformationContainerStyled>
    </StyledCard>
  );
}

export default UnitsCard;

const RoomInformationContainerStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  row-gap: 10px;
  column-gap: 20px;
`;
